import React from "react";

export const SketcherAppContext = React.createContext({});